<template>
  <div class="cooperation-container">
    <TitleBar
      :show-all-pois="false"
      @poiChangeCallback="poiChangeCallback"
    />
    <div>
      <div
        v-if="contractList && contractList.length"
        class="list-box"
      >
        <div
          v-for="(contract, index) in contractList"
          :key="index"
          class="info-main-panel"
        >
          <div class="info-panel">
            <div class="row">
              <div class="left">
                门店名称
              </div>
              <div class="right">
                {{ contract.poiName }}
              </div>
            </div>
            <div class="row">
              <div class="left">
                机柜数量
              </div>
              <div class="right">
                {{ contract.cabinetCount }}台
              </div>
            </div>
            <div
              v-show="contract.showBenefitRate"
              class="row"
            >
              <div class="left">
                门店分成
              </div>
              <div class="right">
                订单收益 * {{ contract.benefitRate }}%
              </div>
            </div>
            <div class="row">
              <div class="left">
                收款账号
              </div>
              <div class="right">
                钱袋宝{{ contract.walletId | idFilter }}
              </div>
            </div>
            <div
              v-if="!isAgent"
              class="row"
            >
              <div class="left">
                发票说明
              </div>
              <div class="right">
                {{ contract.invoiceDesc }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <NoData
        v-else
        tips="没有找到相关记录"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NoData from '@/components/NoData';
import TitleBar from '@/components/TitleBar';
import STATUS from '@/constants/status';
import Contract from '@/api/contract';

export default {
  name: 'Cooperation',
  components: {
    NoData,
    TitleBar,
  },
  filters: {
    idFilter(val) {
      if (!val || val === '0') {
        val = '--';
      }
      return val;
    },
  },
  data() {
    return {
      contractList: [],
    };
  },
  computed: {
    ...mapState(['currentPoi', 'isAgent']),
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * 获取合同信息
     * @returns {Promise.<void>}
     */
    async getData() {
      const {
        poiId,
        // poiStatus,
        // poiSource,
      } = this.currentPoi;
      this.$store.commit('setLoading', true);
      await Contract.getPoiDetail(poiId).then((res) => {
        if (res.code === STATUS.SUCCESS && res.data) {
          this.contractList = res.data;
        } else {
          this.contractList = [];
        }
      });
      this.$store.commit('setLoading', false);
    },
    poiChangeCallback() {
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
.cooperation-container {
  padding-bottom: 170px;
  text-align: left;
  .top-box {
    background: #f5f5f5;
  }
  .list-box {
    margin-top: 100px;
  }
  .top-tip {
    padding: 24px 36px 0;
    font-size: 24px;
    color: rgba(0, 0, 0, .42);
  }
  .info-panel {
    margin: 20px 18px 0;
    padding: 30px 0 30px 36px;
    border-radius: 12px;
    background: #FFF;
    .title {
      line-height: 45px;
      padding-bottom: 24px;
      padding-right: 30px;
      font-size: 26px;
      font-weight: bold;
      text-align: left;
      color: rgba(0, 0, 0, .84);
      letter-spacing: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tips {
        display: flex;
        align-items: center;
      }
      .expr {
        font-size: 26px;
        color: #0A70F5;
        display: flex;
        align-items: center;
        .icon-arrow {
          width: 24px;
          height: 24px;
          margin-left: 6px;
        }
      }
    }
    .icon-success {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
    .single-row {
      padding-top: 24px;
      padding-right: 15px;
      border-top: 1px solid rgba(0, 0, 0, .06);
      font-size: 26px;
      color: rgba(0, 0, 0, .6);
    }
    .row {
      display: flex;
      margin-top: 24px;
      padding-right: 36px;
      line-height: 37px;
      font-size: 26px;
      &:first-child {
        margin-top: 0;
      }
      .left {
        width: 106px;
        margin-right: 18px;
        color: rgba(0, 0, 0, .42);
      }
      .right {
        flex: 1;
        color: rgba(0, 0, 0, .84);
      }
    }
  }
  .bottom-btns {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #FFF;
  }
}
</style>
